import { CurrencyEnum } from '../../enums';
import { CurrencySymbolType } from '../../services/subscription/types';
import { Payment } from '../crm/types';
import { SORErrorResponse } from '../gateway/types';

export enum ReportingCall {
  getNetEquityComponents,
  getAccountSummary,
  getOrderDetail,
  getOpenPositions,
  getAccountTradeHistory,
  getAccountPendingOrders,
  getPeopleAlsoTradeData,
  getFxTransactions,
  getBuiyngPower,
  getLeaderboard,
}

export interface PeopleAlsoTradeParams {
  accountReferenceId: string;
  daysBack: number;
  symbolNumber?: number;
  tenNAccounstOnly: boolean;
}

export enum FxOrderType {
  Buy = 1,
  Sell = 2,
}

export enum FxOrderSideType {
  Buy = '1',
  Sell = '2',
}

export enum FxOrderStatus {
  New = 0,
  Fill = 2,
  Rejected = 4,
}

export interface PeopleAlsoTradeItem {
  symbol: string;
  rowNumber: number;
}

export interface FxCommission {
  commCurr: CurrencyEnum,
  commValue: number,
}

export interface FxOrder {
  boughtAmountCurr: CurrencyEnum;
  boughtAmountValue: number;
  comissions: FxCommission[];
  exchangeRate: number;
  lastUpdatedDate: string;
  orderDate: string;
  orderId: string;
  orderStatus: FxOrderStatus;
  pages: number;
  rowNumber: number;
  side: FxOrderSideType;
  soldAmountCurr: CurrencyEnum;
  soldAmountValue: number;
  symbol: CurrencySymbolType;
  executionId: number;
  fillDate: string;
  orderCurrency: CurrencyEnum;
  tenNStatus: FxOrderStatus;
}

export interface PaymentAndFxOrder {
  isPayment: boolean;
  timestamp: number;
  orderOrPayment: Payment | FxOrder;
}

export interface FxTransactionAccount {
  accountReferenceId: string;
  fxOrders: FxOrder[];
}

export type FxTransactionResponse = SORErrorResponse & {
  accounts: FxTransactionAccount[];
}
